import { defaultTrashFilterDocument } from '@griply/utils';
import Typography from '@mui/material/Typography';
import { useTasksByFilterDocument } from 'features/tasks';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Trash2 } from 'shared/assets/icons';
import { TopBarBase } from 'shared/components/connected/top-bar-base';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { TreeSearchInput } from 'shared/components/ui/tree-search-input';

import { EmptyTrashDialog } from '../empty-trash-dialog';
import * as Styled from './page-top-bar.style';

const filterOptions = { includeArchived: true, includeTaskWithAction: true };

export const PageTopBar: React.FC = () => {
  const { t } = useTranslation();
  const [emptyDialogOpen, setEmptyDialogOpen] = useState(false);

  const trashedTasks = useTasksByFilterDocument(
    defaultTrashFilterDocument,
    filterOptions,
  );

  const openEmptyDialog = () => setEmptyDialogOpen(true);
  const closeEmptyDialog = () => setEmptyDialogOpen(false);

  return (
    <TopBarBase>
      <Styled.Container>
        <Styled.Title>
          <Styled.IconContainer>
            <Trash2 />
          </Styled.IconContainer>
          <Typography variant="h5" component="h1">
            {t('pages.trash.title')}
          </Typography>
        </Styled.Title>

        {!!trashedTasks.length && (
          <Styled.Interactions>
            <TreeSearchInput />
            <Button
              onClick={openEmptyDialog}
              size={Sizes.Small}
              variant={Variants.Outlined}
              color={Colors.Inherit}
              preventDrag
            >
              {t('trash.empty-button')}
            </Button>
          </Styled.Interactions>
        )}
      </Styled.Container>

      {emptyDialogOpen && (
        <EmptyTrashDialog tasks={trashedTasks} onClose={closeEmptyDialog} />
      )}
    </TopBarBase>
  );
};
